// extracted by mini-css-extract-plugin
export default {"StyledTableRow":"table-row-module__StyledTableRow__PluEA1F"};